function Divider() {
  return <div className="border-t mt-3.5 mb-3.5"></div>;
}

export default Divider;
